import { appStore } from "src/appStore";

/**
 * Заголовок мультиязычности.
 *
 * Руками его ставить не нужно - транспорт подставляет сам по флагу translate:
 * rest.get("some url", { translate: true }). Заголовок в отрыве от флага меняет
 * тело ответа, не меняя ключ HTTP-кэша, и ответы разных вариантов смешиваются.
 */
export const langHdr = (): Record<string, string> => ({
  "Content-Language": appStore.curLang,
});
